export default "__VITE_ASSET__BLLPgnob__"